/*
  Grip finder. Deterministic scoring: positive total = Midsize, negative = Skinny,
  zero = Skinny with a note. Products come from the section's vibe blocks and
  are filtered to in-stock variants of the recommended size.
*/
if (!customElements.get('srg-grip-finder')) {
  customElements.define(
    'srg-grip-finder',
    class SrgGripFinder extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.srg-finder__form');
        this.result = this.querySelector('.srg-finder__result');
        this.error = this.querySelector('.srg-finder__error');
        this.links = JSON.parse(this.querySelector('.srg-finder__links').textContent);
        this.products = Array.from(this.querySelector('.srg-finder__data').content.querySelectorAll('li'));
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.recommend();
        });
        this.querySelector('.srg-finder__reset').addEventListener('click', () => this.reset());
      }

      answer(name) {
        const input = this.form.querySelector(`input[name="${name}"]:checked`);
        return input ? input.value : null;
      }

      recommend() {
        const current = this.answer('current');
        const issue = this.answer('issue');
        const head = this.answer('head');
        const vibeInputs = this.form.querySelectorAll('input[name="vibe"]');
        const vibe = vibeInputs.length ? this.answer('vibe') : null;
        if (current === null || issue === null || head === null || (vibeInputs.length && vibe === null)) {
          this.error.hidden = false;
          return;
        }
        this.error.hidden = true;

        const score = Number(current) + Number(issue) + Number(head);
        const size = score > 0 ? 'Midsize' : 'Skinny';
        const copy = {
          Midsize:
            'Bigger and heavier (3.8 oz). It quiets busy hands and wrists and makes the putter head feel steadier through the stroke.',
          Skinny:
            'Slim and light (2.3 oz). You keep more feel in your fingers and the putter head stays noticeable in your stroke.',
        };
        const tie = score === 0 ? ' Honestly, it was close. If your hands get jumpy over short putts, try Midsize.' : '';

        this.result.querySelector('.srg-finder__size').textContent = size;
        this.result.querySelector('.srg-finder__title').textContent = `You're a ${size} putter.`;
        this.result.querySelector('.srg-finder__why').textContent = copy[size] + tie;
        const shop = this.result.querySelector('.srg-finder__shop');
        shop.href = this.links[size];
        shop.textContent = `Shop all ${size}`;

        const hasSize = (li, s) => li.dataset.sizes.split(',').includes(s);
        let picks = this.products.filter((li) => (!vibe || li.dataset.vibe === vibe) && hasSize(li, size));
        if (picks.length < 3) {
          picks = picks.concat(this.products.filter((li) => !picks.includes(li) && hasSize(li, size)));
        }
        const seen = new Set();
        picks = picks.filter((li) => {
          const url = li.querySelector('a').getAttribute('href');
          if (seen.has(url)) return false;
          seen.add(url);
          return true;
        });
        const list = this.result.querySelector('.srg-finder__products');
        list.replaceChildren(
          ...picks.slice(0, 3).map((li) => {
            const card = li.cloneNode(true);
            const match = li.dataset.variants
              .split('||')
              .map((entry) => entry.split('::'))
              .find(([title]) => title === size);
            if (match) {
              const link = card.querySelector('a');
              link.href = `${link.getAttribute('href')}?variant=${match[1]}`;
              card.querySelector('.srg-finder__product-price').textContent = match[2];
            }
            return card;
          })
        );
        list.hidden = list.children.length === 0;

        this.form.hidden = true;
        this.result.hidden = false;
        this.result.querySelector('.srg-finder__title').setAttribute('tabindex', '-1');
        this.result.querySelector('.srg-finder__title').focus();
      }

      reset() {
        this.form.reset();
        this.result.hidden = true;
        this.form.hidden = false;
        this.form.querySelector('input').focus();
      }
    }
  );
}
